import React, { useMemo } from 'react'
import { colors } from '@fs/zion-ui'

export const ColorContext = React.createContext(null)

export default function OfferColorProvider({
  children,
  color = colors.gray100,
  backgroundColor = colors.gray00,
  iconPattern,
}) {
  const colorValues = useMemo(() => {
    return { color, backgroundColor, iconPattern }
  }, [color, backgroundColor, iconPattern])

  return <ColorContext.Provider value={colorValues}>{children}</ColorContext.Provider>
}
